// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"649b1c8e","370":"1972c73a","388":"f1f56c93","391":"aa57cf13","453":"09b6c348","454":"de023083","571":"5dd5b40d","597":"ea40fbbb","599":"0cb16522","800":"437b2adb","853":"2a33f982","854":"7a1dc16e","869":"92c42234","876":"424e1217"}[chunkId] + ".chunk.js";
};